<template>
  <v-container fluid>
    <avs-card class="pb-4">
      <template v-slot:title>
        <div></div>
        <!-- <avs-button
          v-if="isEditable"
          @click="inviteMembers"
          iconI="mdi-account-plus"
          color="accent"
          :spantext="$t('views.team.invite')"
        >
          <template v-slot:name>{{ $t("views.team.invite") }}</template>
        </avs-button> -->
      </template>
      <template v-slot:content>
        <v-data-table
          class="ma-10 bgTable"
          :headers="headers"
          :items="members"
          :no-data-text="$t('messages.information.no_data')"
        >
          <template v-slot:item.avatar="{ item }">
            <v-avatar
              class="my-4 secondary white--text"
              size="40"
            >
              <span>{{ getInitials(item) }}</span>
            </v-avatar>
          </template>

          <template v-slot:item.role="{ item }">
            <avs-role
              v-if="!isRoleEditable(item)"
              :role="item.role ? item.role : 'No role yet'"
              disabled
            />
            <v-edit-dialog
              v-else
              large
              :return-value.sync="item.role"
              @save="editMemberRole(item)"
            >
              <avs-role :role="item.role" />

              <template v-slot:input>
                <div class="my-5 text-h6">{{ $t("views.team.select") }}</div>
                <v-select
                  v-model="item.role"
                  :items="roleItems"
                  chips
                  label="Roles"
                  outlined
                ></v-select>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:item.date_joined="{ item }">
            {{ toDatetime(item.date_joined) }}
          </template>

          <template v-slot:item.status="{ item }">
            <avs-chip
              color="success"
              :disabled="item.status === 'active' ? false : true"
              style="width: 88px"
            >
              {{ get_status(item.status) }}
            </avs-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-btn
                icon
                color="secondary"
                v-if="isRoleEditable(item) && item.role === 'operator'"
                :disabled="!isRoleEditable(item)"
                @click.stop="handleOpenEditDialog(item)"
                :spantext="$t('actions.edit', { entity: $tc('commons.folder', 1).toLowerCase() })"
              >
                <v-icon>mdi-account-plus-outline</v-icon>
              </v-btn>
              <avs-deleteButton
                @click="handleOpenDeleteDialog(item)"
                spantext="Delete member"
                :disabled="!isRoleEditable(item)"
              />
            </div>
          </template>
        </v-data-table>

        <v-dialog
          v-model="editDialogIsOpen"
          width="70vw"
        >
          <component
            v-model="selectedItem"
            :is="editDialogContent"
            :user="selectedUser"
            :isEditable="isEditable"
            @cancel="handleCancel"
            @error="handleError"
            @success="handleSuccess"
          />
        </v-dialog>
        <avs-deleteDialog
          v-model="deleteDialogIsOpen"
          @cancel="handleDeleteCancel"
          @delete="deleteMember"
          resource="Project user"
        />
      </template>
    </avs-card>
  </v-container>
</template>

<script>
import { PROJECT_MEMBER_ROLES } from "@/utils/consts"
import { toDatetime } from "@/utils/datetime"
import { initials } from "@/utils/string"
import PrivilegeEditor from "@/components/ri3/documents/privileges/PrivilegeEditor.vue"
import { PrivilegeService } from "@/services"

export default {
  name: "TeamProjectTable",
  components: { PrivilegeEditor },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    members: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    companyId() {
      return this.$store.state.app.company.id
    }
  },
  data() {
    const headers = [
      { text: this.$t("commons.avatar"), value: "avatar", width: "90" },
      { text: this.$t("commons.first_name"), value: "first_name", class: "min-width-100" },
      { text: this.$t("commons.last_name"), value: "last_name", class: "min-width-100" },
      { text: this.$t("commons.email"), value: "email", class: "min-width-100" },
      { text: this.$t("commons.role"), value: "role", align: "center" },
      { text: this.$t("commons.join_date"), value: "date_joined" },
      { text: this.$t("commons.status.name"), value: "status", align: "center" }
    ]

    if (this.isEditable) {
      headers.push({
        text: "Actions",
        sortable: false,
        value: "actions",
        align: "right",
        width: "90"
      })
    }

    return {
      headers: headers,
      roleItems: PROJECT_MEMBER_ROLES,
      deleteDialogIsOpen: false,

      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined,
      selectedUser: undefined
    }
  },
  methods: {
    async fetchPrivileges(userId) {
      try {
        const response = await PrivilegeService.getUserProjectPrivileges(userId)
        if (response.length > 0) {
          return response[0]
        } else {
          return {
            user: userId,
            actions: []
          }
        }
      } catch (error) {
        console.error("Error fetching privileges:", error)
        return null
      }
    },

    toDatetime,
    getInitials(item) {
      return initials(`${item.first_name} ${item.last_name}`)
    },
    isRoleEditable(item) {
      return this.isEditable && item.role !== "administrator" && item.status != "inactive"
    },
    // action on members
    deleteMember(item) {
      this.$emit("delete-member", this.selectedUser)
      this.deleteDialogIsOpen = false
    },
    editMemberRole(item) {
      this.$emit("edit-member-role", item)
    },
    inviteMembers() {
      this.$emit("invite-members")
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedUser = item
    },
    handleDeleteCancel() {
      this.deleteDialogIsOpen = false
      this.selectedUser = undefined
    },
    get_status(item) {
      if (item == "active") {
        return this.$t("commons.active")
      }
      return this.$t("commons.inative")
    },
    // handleOpenEditDialog(item) {
    //   this.selectedItem = this.fetchPrivileges(item.id, this.companyId)
    //   alert(this.selectedItem)
    //   this.selectedUser = item
    //   this.handleOpenEditDialogByComponent()
    // },
    async handleOpenEditDialog(item) {
      this.selectedUser = item
      this.selectedItem = await this.fetchPrivileges(item.id)

      if (this.selectedItem || this.selectedItem.length === 0) {
        this.handleOpenEditDialogByComponent()
      }
    },

    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true
      this.editDialogContent = "PrivilegeEditor"
    },
    handleCancel() {
      this.selectedItem = undefined
      this.editDialogIsOpen = false
      this.editDialogContent = null
    },
    handleError(message) {
      this.send(message || this.$t("messages.error.failed_admin", { role: "INSPECTOR" }), "error")
    },
    handleSuccess() {
      this.handleCancel()
      this.$nextTick(() => {
        // this.fetchFieldTypes()
        this.send(this.$t("messages.success.operation"), "success")
      })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
